import React from "react";
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import Paper from "@material-ui/core/Paper";
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from "@material-ui/core/TableContainer";
import Box from "@material-ui/core/Box";

export default class ComponentToPrint extends React.Component {

    render() {

        const reportData = this.props.reportData;
        const searchData = this.props.searchData;

        let totQty = 0;
        reportData.forEach(x => {
            totQty = x.qty + totQty;
        });

        let totDays = 0;
        const groupedData = reportData.reduce((acc, item) => {
            if (!acc[item.date.split('T')[0]]) {
              acc[item.date.split('T')[0]] = [];
            }
            acc[item.date.split('T')[0]].push(item);
            return acc;
          }, {});
          totDays =Object.keys(groupedData).length

        return (
            <div className="pl-2 pr-2">
                <h3><center><u>Lent Contract Details Report</u></center></h3>
                <div className="row pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Estate: </b> {searchData.estate}</div>
                    <div className="col"><b>Division: </b> {searchData.division}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <div>
                                <Box display="flex" justifyContent="flex-end" p={2}>
                                    <TableContainer component={Paper}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Arival Date</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Field Number</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent RS Sub Block</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Block Owner Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Supplier Number\Reg Number</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Lent Supplier\Reg Worker Name</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>QtyPlucked</TableCell>
                                                    <TableCell align="center" style={{ fontWeight: "bold", border: "2px solid black" }}>Operator</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {reportData.map((row, i) => (
                                                    <TableRow key={i} style={{ border: "2px solid black" }}>
                                                        <TableCell component="th" scope="row" align="center" style={{ border: "2px solid black" }}>{row.date.split('T')[0]}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.fieldName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.subBlock}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.blockOwnerName}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.supplierRegNo}</TableCell>
                                                        <TableCell component="th" scope="row" align="left" style={{ border: "2px solid black" }}>{row.workerName}</TableCell>
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>{row.qty}</TableCell>
                                                        <TableCell component="th" scope="row" align="right" style={{ border: "2px solid black" }}>{row.userName}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                            <TableBody>
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell component="th" scope="row" align="left" style={{fontWeight: "bold", border: "2px solid black" }} colSpan={6}>Total Qty</TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{fontWeight: "bold", border: "2px solid black" }}>{totQty}</TableCell>
                                                </TableRow>
                                                <TableRow style={{ border: "2px solid black" }}>
                                                    <TableCell component="th" scope="row" align="left" style={{ fontWeight: "bold", border: "2px solid black" }} colSpan={6}>Total Days</TableCell>
                                                    <TableCell component="th" scope="row" align="right" style={{ fontWeight: "bold", border: "2px solid black" }}>{totDays}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
